(function () {
  function init() {
    document.querySelectorAll('.pv-section').forEach(function (section) {
      var modal = section.querySelector('.pv-modal');
      var modalVideo = modal ? modal.querySelector('video') : null;
      var closeBtn = modal ? modal.querySelector('.pv-modal__close') : null;
      var trigger = null;
      var modalParent = modal ? modal.parentNode : null;

      // Move modal to body so it escapes all stacking contexts (sticky, z-index)
      if (modal && modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }

      // Click card → open modal
      section.addEventListener('click', function (e) {
        var card = e.target.closest('.pv-card');
        if (card) {
          e.preventDefault();
          e.stopPropagation();
          openModal(card);
        }
      });

      // Keyboard support
      section.addEventListener('keydown', function (e) {
        var card = e.target.closest('.pv-card');
        if (card && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          openModal(card);
        }
      });

      // Close modal
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (modal) modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });

      function openModal(card) {
        var url = card.getAttribute('data-video-url');
        if (!url || !modalVideo || !modal) return;

        // Pause inline preview
        var preview = card.querySelector('.pv-card__preview');
        if (preview) preview.pause();

        modalVideo.innerHTML = '';
        var source = document.createElement('source');
        source.src = url;
        source.type = card.getAttribute('data-video-type') || 'video/mp4';
        modalVideo.appendChild(source);
        modalVideo.load();
        modalVideo.play().catch(function () {});

        modal.setAttribute('open', '');
        document.body.classList.add('pv-modal-open');
        trigger = card;
        if (closeBtn) closeBtn.focus();
        document.addEventListener('keydown', onEsc);
      }

      function closeModal() {
        if (!modal || !modal.hasAttribute('open')) return;
        modalVideo.pause();
        modalVideo.innerHTML = '';
        modal.removeAttribute('open');
        document.body.classList.remove('pv-modal-open');
        document.removeEventListener('keydown', onEsc);

        // Resume inline preview
        if (trigger) {
          var preview = trigger.querySelector('.pv-card__preview');
          if (preview) { preview.muted = true; preview.play().catch(function () {}); }
          trigger.focus();
        }
      }

      function onEsc(e) { if (e.key === 'Escape') closeModal(); }

      // Pause/play videos based on visibility
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target.querySelector('.pv-card__preview');
            if (!video) return;
            if (entry.isIntersecting) {
              video.muted = true;
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.2 });

        section.querySelectorAll('.pv-card').forEach(function (card) {
          observer.observe(card);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when the Shopify theme editor re-renders sections/blocks
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
